import React from "react";

interface IFaqTitleComponentProps {}

export const FaqTitleComponent: React.FC<IFaqTitleComponentProps> = (
    props: IFaqTitleComponentProps
) => {
    return (
        <div
            className="content px-xl-5"
            data-aos="fade-up"
            data-aos-delay="100"
        >
            <h3>
                <span>Frequently Asked </span>
                <strong>Questions</strong>
            </h3>
        </div>
    );
};
